import "./index.scss";
import React, { useEffect, useState } from "react";
import wrapper from "./wrapper";
import zhCN from "antd/locale/zh_CN";
import {
  Drawer,
  Space,
  Button,
  ConfigProvider,
  message,
  List,
  Image,
  Typography,
  Upload,
  Empty,
  Input,
  DatePicker,
} from "antd";
import { CloseOutlined, SyncOutlined } from "@ant-design/icons";
import Api from "../../apis/index";
import MessageModal from "../MessageModal/index";
import emptyImg from "../../assets/暂无icon.png";
import { isImage } from "../../unit/unit";
import dayjs from "dayjs";

const { Paragraph } = Typography;
const { Dragger } = Upload;
const { TextArea } = Input;

const ImageDrawer = (props) => {
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [imgList, setImgList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [deleteList, setDeleteList] = useState([]);
  const {
    /* 标题 */
    title,
    /* 关闭触发的回调 */
    onCancel,
    /* 确定触发的回调 */
    onOk,
    /* 销毁组件回调(高阶组件自定义) */
    closeDialog,
    /* 公司名称 */
    companyName,
    /* 任务id */
    task_id,
    /* 网站id */
    web_id,
    /* 类型 1:检索结果 2:详情 */
    type,
    /* 自然人企业名称 */
    company,
    /* 身份证号 */
    id_card,
    /* 所在地区 */
    area,
  } = props;

  // 关闭
  const handleCancel = () => {
    onCancel && onCancel();
    setVisible(false);
    setTimeout(() => {
      closeDialog();
    }, 500);
  };

  // 确定
  const handleOk = () => {
    if (imgList.length === 0 && deleteList.length === 0) {
      message.error("请上传截图后再保存");
      return;
    }
    // let notHas = false;
    // imgList.forEach((item) => {
    //   if (!item.check_url || !item.watermark_time) {
    //     notHas = true;
    //   }
    // });
    // if (notHas) {
    //   message.error("请完善水印信息后再保存");
    //   return;
    // }
    let editArr = [];
    imgList.forEach((item) => {
      if (item.is_edit) {
        item.full_path_url = item.screenshot_path;
        editArr.push(item);
      }
    });
    if (editArr.length !== 0 || deleteList.length !== 0) {
      const params = {
        task_id: task_id,
        web_id: web_id,
        type: type,
        target_name: companyName,
        company: company,
        id_card: id_card,
        area: area,
        edit_files_paths: editArr,
        delete_files_paths: deleteList,
      };
      setLoading(true);
      Api.saveCheckFile(params).then((res) => {
        if (res.code === 200) {
          message.success(res.message);
          onOk && onOk();
          setVisible(false);
          setTimeout(() => {
            closeDialog();
          }, 500);
        } else {
          message.error(res.message);
        }
        setLoading(false);
      });
    } else {
      onOk && onOk();
      setVisible(false);
      setTimeout(() => {
        closeDialog();
      }, 500);
    }
  };

  // 获取图片列表
  const getImageList = () => {
    let params = {
      name: companyName,
      company: company,
      id_card: id_card,
      area: area,
      check_id: task_id,
      web_id: web_id,
    };
    Api.getCheckImagesPaths(params)
      .then((res) => {
        if (res.code === 200) {
          const full_detail_paths = res.data?.full_detail_paths || [];
          const full_list_search_paths = res.data?.full_list_search_paths || [];
          const list = type === 1 ? full_list_search_paths : full_detail_paths;
          let imgList = [];
          let fileList = [];
          list.forEach((item, index) => {
            if (isImage(item.screenshot_path)) {
              imgList.push(item);
            } else {
              fileList.push(item);
            }
          });
          setImgList(imgList);
          setFileList(fileList);
        } else {
          message.error(res.message);
          handleCancel();
        }
      })
      .catch((sea) => {
        message.error(sea.message || "请求出错，请稍后重试");
        handleCancel();
      });
  };

  // 上传图片
  const handleFileChange = (info) => {
    const formData = new FormData();
    formData.append("file[]", info.file?.originFileObj);

    Api.uploadImages(formData).then((res) => {
      if (res.code === 200) {
        message.success("上传成功");
        const obj = {
          screenshot_path: res.data?.at(0).full_path_url,
          watermark_time: null,
          check_url: null,
          is_edit: true,
        };
        setImgList([...imgList, obj]);
      } else {
        message.error(res.message);
      }
    });
  };

  useEffect(() => {
    if (visible) {
      getImageList();
    }
  }, [visible]);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#0068B2",
        },
        components: {
          Input: {
            borderRadius: 4, // 正常状态圆角
          },
          DatePicker: {
            borderRadius: 4, // 正常状态圆角
          },
          Button: {
            borderRadius: 4, // 正常状态圆角
          },
        },
      }}
    >
      <Drawer
        title={title || "图片预览"}
        onClose={handleCancel}
        open={visible}
        width={600}
        closable={false}
        className="myDrawer imageDrawer"
        extra={<CloseOutlined onClick={handleCancel} />}
        footer={
          <Space size="middle" align="center" direction="horizontal">
            <Button onClick={handleCancel}>取消</Button>
            <Button type="primary" onClick={handleOk} loading={loading}>
              保存
            </Button>
          </Space>
        }
      >
        <div className="imageDrawerContent">
          {imgList.length > 0 ? (
            <List
              bordered={false}
              dataSource={imgList}
              renderItem={(item, index) => (
                <List.Item>
                  <div className="imgBox">
                    <Image
                      width={180}
                      height="100%"
                      src={item.screenshot_path}
                    />
                  </div>
                  <div className="textBox">
                    <div className="titleBox">水印设置</div>
                    <div className="infoBox">
                      <div className="descBox">
                        {item.is_edit || item.is_new_add ? (
                          <div className="descItem">
                            <span>核查网站:</span>
                            <TextArea
                              placeholder="请输入核查网站"
                              value={item.check_url}
                              onChange={(e) => {
                                const newList = [...imgList];
                                newList[index].check_url = e.target.value;
                                newList[index].is_edit = true;
                                setImgList(newList);
                              }}
                            />
                          </div>
                        ) : (
                          <Paragraph
                            style={{ width: "100%", marginBottom: "0" }}
                            ellipsis={{
                              tooltip: item.check_url,
                              rows: 3,
                            }}
                          >
                            <span>核查网站:</span>
                            {item.check_url}
                          </Paragraph>
                        )}
                      </div>
                      <div className="descBox">
                        {item.is_edit || item.is_new_add ? (
                          <>
                            <span>核查时间:</span>
                            <DatePicker
                              format="YYYY-MM-DD HH:mm:ss"
                              showTime={true}
                              allowClear={false}
                              value={
                                item.watermark_time
                                  ? dayjs(item.watermark_time)
                                  : null
                              }
                              onChange={(date, dateString) => {
                                const newList = [...imgList];
                                newList[index].watermark_time = dateString;
                                newList[index].is_edit = true;
                                setImgList(newList);
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <span>核查时间:</span>
                            {item.watermark_time}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="iconBox">
                      <span
                        className="iconItem"
                        onClick={(e) => {
                          e.stopPropagation();
                          MessageModal({
                            type: "warning",
                            description: "确定要删除这张截图吗？",
                            title: "删除",
                            onOk: () => {
                              if (item.id) {
                                // 只有存在id的图片才需要添加到删除列表
                                setDeleteList([...deleteList, item.id]);
                              }
                              setImgList(imgList.filter((_, i) => i !== index));
                            },
                          });
                        }}
                      >
                        <svg
                          fill="none"
                          version="1.1"
                          width="15.14990234375"
                          height="16.14990234375"
                          viewBox="0 0 15.14990234375 16.14990234375"
                        >
                          <g>
                            <g>
                              <path
                                d="M9.847077466125487,13.534786463165283L9.847077466125487,5.638324463165283C9.847077466125487,5.352412463165283,9.619367466125489,5.120636463165283,9.338487466125489,5.120636463165283C9.057597466125488,5.120636463165283,8.829897466125487,5.352412463165283,8.829897466125487,5.638324463165283L8.829897466125487,13.534786463165283C8.829897466125487,13.820696463165284,9.057597466125488,14.052476463165283,9.338487466125489,14.052476463165283C9.619367466125489,14.052476463165283,9.847077466125487,13.820696463165284,9.847077466125487,13.534786463165283ZM6.273387466125488,13.534786463165283L6.273387466125488,5.638324463165283C6.273387466125488,5.352412463165283,6.045683466125488,5.120636463165283,5.764797466125488,5.120636463165283C5.483910466125488,5.120636463165283,5.256207466125488,5.352412463165283,5.256207466125488,5.638324463165283L5.256207466125488,13.534786463165283C5.256207466125488,13.820696463165284,5.483910466125488,14.052476463165283,5.764797466125488,14.052476463165283C6.045683466125488,14.052476463165283,6.273387466125488,13.820696463165284,6.273387466125488,13.534786463165283Z"
                                fill="currentColor"
                                fill-opacity="1"
                              />
                              <path
                                d="M5.351668966125488,13.953406463165283Q5.522675466125488,14.127476463165284,5.764797466125488,14.127476463165284Q6.006918466125488,14.127476463165284,6.1779254661254885,13.953406463165283Q6.348387466125488,13.779896463165283,6.348387466125488,13.534786463165283L6.348387466125488,5.638324463165283Q6.348387466125488,5.393213463165283,6.1779254661254885,5.219702763165283Q6.006917466125488,5.045636463165283,5.764797466125488,5.045636463165283Q5.522676466125488,5.045636463165283,5.3516687661254885,5.219702763165283Q5.181207466125488,5.393213463165283,5.181207466125488,5.638324463165283L5.181207466125488,13.534786463165283Q5.181207466125488,13.779896463165283,5.351668966125488,13.953406463165283ZM8.925357466125488,13.953406463165283Q9.09636746612549,14.127476463165284,9.338487466125489,14.127476463165284Q9.580607466125489,14.127466463165284,9.751617466125488,13.953406463165283Q9.922077466125488,13.779896463165283,9.922077466125488,13.534786463165283L9.922077466125488,5.638324463165283Q9.922077466125488,5.393212463165283,9.751617466125488,5.219702763165283Q9.580607466125489,5.045636463165283,9.338487466125489,5.045636463165283Q9.09636746612549,5.045636463165283,8.925357466125488,5.219702763165283Q8.754897466125488,5.393213463165283,8.754897466125488,5.638324463165283L8.754897466125488,13.534786463165283Q8.754897466125488,13.779896463165283,8.925357466125488,13.953406463165283ZM6.070923466125488,13.848286463165284Q5.944005466125488,13.977476463165283,5.764797466125488,13.977476463165283Q5.585588466125488,13.977476463165283,5.458670466125488,13.848286463165284Q5.3312074661254885,13.718536463165282,5.3312074661254885,13.534786463165283L5.3312074661254885,5.638324463165283Q5.3312074661254885,5.454568463165283,5.458670466125488,5.3248244631652835Q5.585588466125488,5.195636463165283,5.764797466125488,5.195636463165283Q5.944005466125488,5.195636463165283,6.070923466125488,5.3248244631652835Q6.198386466125489,5.454568463165283,6.198386466125489,5.638324463165283L6.198386466125489,13.534786463165283Q6.198386466125489,13.718536463165282,6.070923466125488,13.848286463165284ZM9.644607466125489,13.848286463165284Q9.517697466125489,13.977476463165283,9.338487466125489,13.977476463165283Q9.159277466125488,13.977476463165283,9.032357466125488,13.848286463165284Q8.904897466125488,13.718546463165284,8.904897466125488,13.534786463165283L8.904897466125488,5.638323463165284Q8.904897466125488,5.454568463165283,9.032357466125488,5.3248244631652835Q9.159277466125488,5.195636463165283,9.338487466125489,5.195636463165283Q9.517697466125489,5.195636463165283,9.644607466125489,5.3248244631652835Q9.772077466125488,5.454567463165283,9.772077466125488,5.638324463165283L9.772077466125488,13.534786463165283Q9.772077466125488,13.718546463165284,9.644607466125489,13.848286463165284Z"
                                fill-rule="evenodd"
                                fill="currentColor"
                                fill-opacity="1"
                              />
                            </g>
                            <g>
                              <path
                                d="M6.442491171875,1.110331171875L8.714191171875,1.110331171875C8.995081171875,1.110331171875,9.222781171875,0.878550171875,9.222781171875,0.592639171875C9.222781171875,0.306728171875,8.995081171875,0.0749511323786,8.714191171875,0.074951171875L6.442491171875,0.074951171875C6.161601171875,0.0749511323786,5.933901171875,0.306728171875,5.933901171875,0.592639171875C5.933901171875,0.878550171875,6.161601171875,1.110331171875,6.442491171875,1.110331171875ZM14.566351171875,1.911021171875L0.583541171875,1.911021171875C0.302654171875,1.911021171875,0.074951171875,2.142791171875,0.074951171875,2.428701171875C0.074951171875,2.714611171875,0.302654171875,2.946391171875,0.583541171875,2.946391171875L14.566351171875,2.946391171875C14.847251171875,2.946391171875,15.074951171875,2.714611171875,15.074951171875,2.428701171875C15.074951171875,2.142791171875,14.847251171875,1.911021171875,14.566351171875,1.911021171875M13.210151171875,3.912741171875C12.929251171875,3.912741171875,12.701551171875,4.144521171875,12.701551171875,4.430431171875L12.701551171875,15.039551171875L2.448371171875,15.039551171875L2.448371171875,4.430431171875C2.448371171875,4.144521171875,2.220661171875,3.912741171875,1.939781171875,3.912741171875C1.658891171875,3.912741171875,1.431191171875,4.144521171875,1.431191171875,4.430431171875L1.431191171875,15.557251171875C1.431191171875,15.843151171875,1.658891171875,16.074951171875,1.939781171875,16.074951171875L13.210151171875,16.074951171875C13.491051171875,16.074951171875,13.718751171875,15.843151171875,13.718751171875,15.557251171875L13.718751171875,4.430431171875C13.718751171875,4.144521171875,13.491051171875,3.912741171875,13.210151171875,3.912741171875Z"
                                fill="currentColor"
                                fill-opacity="1"
                              />
                              <path
                                d="M6.029361171875,0.174017571875Q5.858901171875,0.347528171875,5.858901171875,0.592639171875Q5.858901171875,0.837749171875,6.029361171875,1.011260171875Q6.200371171875,1.185331171875,6.442491171875,1.185331171875L8.714191171875,1.185331171875Q8.956311171875,1.185331171875,9.127321171875,1.011260171875Q9.297781171875,0.837748171875,9.297781171875,0.592639171875Q9.297781171875,0.347529171875,9.127321171875,0.174017571875Q8.956311171875,-0.000048828124999997224,8.714191171875,-0.000048828124999997224L6.442491171875,-0.000048828124999997224Q6.200371171875,-0.000048828124999997224,6.029361171875,0.174017571875ZM6.136371171875,0.906138171875Q6.008901171875,0.776395171875,6.008901171875,0.592639171875Q6.008901171875,0.408883171875,6.136371171875,0.27913917187500004Q6.263281171875,0.149951171875,6.442491171875,0.149951171875L8.714191171875,0.149951171875Q8.893401171875,0.149951171875,9.020321171875,0.27913917187500004Q9.147781171875,0.408884171875,9.147781171875,0.592639171875Q9.147781171875,0.776394171875,9.020321171875,0.906138171875Q8.893401171875,1.0353271718750001,8.714191171875,1.035326171875L6.442491171875,1.0353271718750001Q6.263281171875,1.0353271718750001,6.136371171875,0.906138171875ZM14.979451171875,2.010081171875Q14.808451171875,1.836021171875,14.566351171875,1.836021171875L0.583540171875,1.836021171875Q0.341419171875,1.836021171875,0.170412471875,2.010081171875Q-0.000048828124999997224,2.183591171875,-0.000048828124999997224,2.428701171875Q-0.000048828124999997224,2.673811171875,0.170412571875,2.847331171875Q0.341420171875,3.021391171875,0.583541171875,3.021391171875L14.566351171875,3.021391171875Q14.808451171875,3.021391171875,14.979451171875,2.847331171875Q15.149951171875,2.673811171875,15.149951171875,2.428701171875Q15.149951171875,2.183601171875,14.979451171875,2.010081171875ZM0.583541171875,1.986021171875L14.566351171875,1.986021171875Q14.745551171875,1.986021171875,14.872451171875,2.115201171875Q14.999951171875,2.244951171875,14.999951171875,2.428701171875Q14.999951171875,2.612461171875,14.872451171875,2.742201171875Q14.745551171875,2.871391171875,14.566351171875,2.871391171875L0.583541171875,2.871391171875Q0.404332171875,2.871391171875,0.277414171875,2.742201171875Q0.149951171875,2.612461171875,0.149951171875,2.428701171875Q0.149951171875,2.244951171875,0.277414171875,2.115201171875Q0.404332171875,1.986021171875,0.583541171875,1.986021171875ZM13.793751171875,15.557251171875L13.793751171875,4.430431171875Q13.793751171875,4.185321171875,13.623251171875,4.011811171874999Q13.452251171875,3.837741171875,13.210151171875,3.837741171875Q12.968051171875,3.837741171875,12.796951171875,4.011811171874999Q12.626551171875,4.185321171875,12.626551171875,4.430431171875L12.626551171875,14.964551171875L2.523371171875,14.964551171875L2.523371171875,4.430431171875Q2.523371171875,4.185321171875,2.352911171875,4.011811171874999Q2.181901171875,3.837741171875,1.939781171875,3.837741171875Q1.697661171875,3.837741171875,1.526651171875,4.011811171874999Q1.356191171875,4.185321171875,1.356191171875,4.430431171875L1.356191171875,15.557251171875Q1.356191171875,15.802351171875,1.526651171875,15.975851171875Q1.697661171875,16.149951171875,1.939781171875,16.149951171875L13.210151171875,16.149951171875Q13.452251171875,16.149951171875,13.623251171875,15.975851171875Q13.793751171875,15.802351171875,13.793751171875,15.557251171875ZM13.516251171875,4.116931171875Q13.643751171875,4.246671171875,13.643751171875,4.430431171875L13.643751171875,15.557251171875Q13.643751171875,15.741051171875,13.516251171875,15.870751171875Q13.389351171875,15.999951171875,13.210151171875,15.999951171875L1.939781171875,15.999951171875Q1.760571171875,15.999951171875,1.633651171875,15.870751171875Q1.506191171875,15.741051171875,1.506191171875,15.557251171875L1.506191171875,4.430431171875Q1.506191171875,4.246671171875,1.633651171875,4.116931171875Q1.760571171875,3.987741171875,1.939781171875,3.987741171875Q2.118991171875,3.987741171875,2.245901171875,4.116931171875Q2.373371171875,4.246671171875,2.373371171875,4.430431171875L2.373371171875,15.114551171875L12.776551171875,15.114551171875L12.776551171875,4.430431171875Q12.776551171875,4.246671171875,12.903951171875,4.116931171875Q13.030951171875,3.987741171875,13.210151171875,3.987741171875Q13.389351171875,3.987741171875,13.516251171875,4.116931171875Z"
                                fill-rule="evenodd"
                                fill="currentColor"
                                fill-opacity="1"
                              />
                            </g>
                          </g>
                        </svg>
                        删除
                      </span>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          ) : (
            <div className="emptyBox">
              <Empty image={emptyImg} description="暂无数据" />
            </div>
          )}

          <Dragger
            className="uploadBox"
            name="file"
            fileList={[]}
            multiple={false}
            onChange={handleFileChange}
            showUploadList={false}
            accept="image/*"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: "#D8D8D8",
                fontSize: '12px',
                fontWeight: 'bold'
              }}
            >
              <svg
                t="1758261831202"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9453"
                width="36"
                height="36"
              >
                <path
                  d="M642.645333 746.666667H298.666667a149.333333 149.333333 0 0 1 0-298.666667h1.173333a192 192 0 1 1 382.762667-15.936A170.730667 170.730667 0 0 0 642.645333 746.666667z m124.117334-204.501334v182.144a21.333333 21.333333 0 1 1-42.666667 0v-182.144l-69.013333 69.013334a21.333333 21.333333 0 0 1-30.165334-30.186667l105.408-105.408a21.269333 21.269333 0 0 1 30.186667 0l105.408 105.408a21.333333 21.333333 0 0 1-30.165333 30.186667l-68.992-69.013334z"
                  fill="#D8D8D8"
                  p-id="9454"
                ></path>
              </svg>
              <p>上传文件</p>
            </div>
          </Dragger>
        </div>
      </Drawer>
    </ConfigProvider>
  );
};
export default wrapper(ImageDrawer);
